import { objectSwapKeysAndValues } from '@dazn/peng-html5-tools-utils';
import { getFeatureIdFromMessageParams } from './getFeatureNameFromMessageParams';
var getMessageKeyFromParams = function (packageNamespace, featureNumber, id, messages) {
    var featureName = getFeatureIdFromMessageParams(packageNamespace, featureNumber, messages);
    var messageIdModule = messages[featureName].ids;
    var exports = Object.keys(messageIdModule);
    if (exports.length > 1) {
        throw new Error("Multiple named exports found for \"".concat(featureName, "\" message ID module.") +
            "Message ID modules may export a single named const enum export only.");
    }
    var firstAndOnlyNamedExport = messageIdModule[exports[0]];
    var messageLookupTable = objectSwapKeysAndValues(firstAndOnlyNamedExport);
    return messageLookupTable[id];
};
export { getMessageKeyFromParams as getMessageKeyFromNamespaceAndId };
//# sourceMappingURL=getMessageKeyFromParams.js.map